/**
 * 弹窗提示组件
 * @author xiaohu
 * @createtime 2023/02/20
 * @document https://aiban.coding.net/p/hzty-ui-docs/wiki/200
 */

import Vue from 'vue';
import main from './main.vue';

const Confrim = Vue.extend(main);

Confrim.install = function(content, title, options = {}) {
  let _options = null;
  if (arguments && arguments.length === 3) {
    _options = Object.assign({ content, title }, options);
  }

  if (arguments && arguments.length === 2) {
    _options = Object.assign({ content: undefined, title: arguments[0] }, arguments[1]);
  }

  if (arguments && arguments.length === 1) {
    _options = Object.assign({ content: undefined, title: '提示' }, arguments[0]);
  }

  const instance = new Confrim({ data: _options }).$mount();

  document.getElementById('app').appendChild(instance.$el);

  return instance.confirm();
};

export default Confrim;
